import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {openModal, closeModal, getInitialState} from '@web/slices/modal/slice'

import type {MakeCreateSliceOptions, SliceReducers} from './interfaces'
import type {ModalState} from '@web/slices/modal/slice'

export default (options?: MakeCreateSliceOptions) =>
    createSlice<ModalState, SliceReducers, 'modal', SliceSelectors<ModalState>>({
        name: 'modal',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(openModal, (state, {payload}) => {
                    state.case = payload
                })
                .addCase(closeModal, (state) => {
                    state.case = null
                })
            options?.extraReducers?.(builder)
        },
    })
